import React from 'react';
export function LockIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M14 15a2 2 0 01-1.417 1.914L13 19h-2l.417-2.086A2 2 0 1114 15z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9V7a5 5 0 015-5h2a5 5 0 015 5v2h4v12a1 1 0 01-1 1H3a1 1 0 01-1-1V9h4zm2-2a3 3 0 013-3h2a3 3 0 013 3v2H8V7zm12 4v9H4v-9h16z"
  }));
}